import { BRAND_COLORS } from '~/theme/colors';

export const APP_NAME = 'RadNeo™';
export const APP_SUBTITLE = 'AI-Powered Radiology Workflow';
export const APP_DESCRIPTION = 'AI-powered radiology dictation, reporting, and workflow management';
export const COMPANY_NAME = 'UEvolveAI';

/** Re-exported from theme/colors.ts — single canonical source of truth. */
export { BRAND_COLORS };
